import * as actionTypes from 'modules/appointmentTask/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

const initialState = false;

const isLoading = () => true;
const isEnding = () => false;

export default createReducer(initialState, {
  [actionTypes.POST_CLIENT_DOCUMENT_REQUEST]: isLoading,
  [actionTypes.POST_SUCCESS]: isEnding,
  [actionTypes.POST_FAILURE]: isEnding,
  [actionTypes.DELETE_CLIENT_DOCUMENT_REQUEST]: isLoading,
  [actionTypes.DELETE_SUCCESS]: isEnding,
  [actionTypes.DELETE_FAILURE]: isEnding,
});
